import React from 'react';

export type IssuesTab = 'issues' | 'done';

type IssuesTabsProps = {
  active: IssuesTab;
  issuesCount: number;
  doneCount: number;
  onChange: (tab: IssuesTab) => void;
};

export function IssuesTabs({ active, issuesCount, doneCount, onChange }: IssuesTabsProps) {
  return (
    <div className="flex gap-1 border-b border-slate-200" role="tablist">
      <TabButton
        active={active === 'issues'}
        label="Today's Wrk"
        count={issuesCount}
        onClick={() => onChange('issues')}
      />
      <TabButton
        active={active === 'done'}
        label="Done"
        count={doneCount}
        onClick={() => onChange('done')}
      />
    </div>
  );
}

function TabButton({
  active,
  label,
  count,
  onClick
}: {
  active: boolean;
  label: string;
  count: number;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={[
        'px-3 py-2 text-sm font-medium transition-colors',
        'border-b-2 -mb-px',
        active
          ? 'border-slate-900 text-slate-900'
          : 'border-transparent text-slate-500 hover:text-slate-700'
      ].join(' ')}>
      {label}
      <span
        className={[
          'ml-2 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full px-1.5 text-xs',
          active ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'
        ].join(' ')}>
        {count}
      </span>
    </button>
  );
}
